import { addCircleSolidIcon } from "./add-circle-solid";
import { addCircleIcon } from "./add-circle.icon";
import { archiveIcon } from "./archive";
import { catalogIcon } from "./catalog";
import { dragDropIcon } from "./drag-drop";
import { folderSearchIcon } from "./folder-search";
import { libraryIcon } from "./library";
import { managementIcon } from "./management";
import { marketplaceIcon } from "./marketplace";
import { monitorIcon } from "./monitor";
import { pencilIcon } from "./pencil";
import { removeIcon } from "./remove";
import { removeSquareIcon } from "./remove-square";
import { rightArrowCircleIcon } from "./right-arrow-circle";
import { shareIcon } from "./share";
import { spaceConfigIcon } from "./space-config";
import { trackerIcon } from "./tracker";
import { trashCircleIcon } from "./trash-circle";
import { serviceMatrixIcon } from "./service-matrix";
import { tickIcon } from "./tick";
import { circleLeftRegularIcon } from "./circle-left-regular";
import { printSolidIcon } from "./print-solid";

export const CommonIcons = [
    addCircleIcon,
    archiveIcon,
    pencilIcon,
    dragDropIcon,
    rightArrowCircleIcon,
    folderSearchIcon,
    shareIcon,
    removeIcon,
    removeSquareIcon,
    addCircleSolidIcon,
    trashCircleIcon,
    catalogIcon,
    managementIcon,
    marketplaceIcon,
    spaceConfigIcon,
    monitorIcon,
    libraryIcon,
    trackerIcon,
    serviceMatrixIcon,
    tickIcon,
    circleLeftRegularIcon,
    printSolidIcon
]